import { trackFbqEvent } from "~/events/fbqEventFactory";
import { gAdsAccountConversionEvent } from "~/events/gAdsFactory";
import { trackersFactory } from "~/events/trackersFactory";

export const emailTrackerStem = "onboarding-email-page";
const trackers = trackersFactory(emailTrackerStem);
const trackersAccountCreated = trackersFactory("onboarding");

const consumerHealthPrivacyNotice = (): void =>
  trackers({ action: "consumer-health-privacy-notice" });

const privacyLink = (): void => trackers({ action: "privacy-policy-link" });

const submit = (): void => {
  trackers({ action: "submit-sign-up-cta" });
};

const submitSuccess = (): void => {
  trackersAccountCreated({
    action: "account_created",
    label: "Account Created",
  });
  trackFbqEvent("CompleteRegistration");
  gAdsAccountConversionEvent();
};

const termsLink = (): void => trackers({ action: "terms-of-service-link" });

export const trackEmail = {
  consumerHealthPrivacyNotice,
  privacyLink,
  submit,
  submitSuccess,
  termsLink,
};
